module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/not-found/not-found.component.css
// module id = ./src/app/components/not-found/not-found.component.css
// module chunks = main